import * as React from "react";
import {useEffect, useState} from "react";
import HomeRight from "../../../../assets/images/home_right.png";
import StageAllClear from "../../../../assets/images/daily_stage_all_clear.png";
import StageHalfClear from "../../../../assets/images/daily_stage_half_clear.png";
import StageNoneClear from "../../../../assets/images/daily_stage_none_clear.png";
import StageLineOn from "../../../../assets/images/daily_stage_line_on.png";
import StageLineOff from "../../../../assets/images/daily_stage_line_off.png";
import {useNavigate} from "react-router-dom";

const StageBadgeDaily = ({index, stageSummary, stage, setStage, setSubMenu, classInfo, level}) => {
    const [stageInfo, setStageInfo] = useState(null);
    const [round1, setRound1] = useState(0);
    const [round2, setRound2] = useState(0);
    const [round3, setRound3] = useState(0);
    const [allStudents, setAllStudents] = useState([]);

    const thumbNailDomain = "https://sym008463-sym008463.ktcdn.co.kr/stage_thumbnails/";

    const navigate = useNavigate();

    const getThumbnailUrl = (fileName) => {
        return thumbNailDomain+fileName+".png";
    }

    const stageDetail = () => {
        // console.log(stage);
        // setStage(stage.stageInfo);
        // setSubMenu("stage");
        navigate("/page/classDailyStage?classId="+classInfo.classId+"&stageId="+stageInfo.stageId+"&level="+level.level)
    }



    useEffect(() => {
        if(stageSummary){
            setStageInfo(stageSummary.stageInfo);
            setRound1(stageSummary.round1Count);
            setRound2(stageSummary.round2Count);
            setRound3(stageSummary.round3Count);
            setAllStudents(stageSummary.allStudentsCount);
        }
    }, [stageSummary]);


    return (
        <div className="flex flex-col w-full max-w-[510px] mb-5">
            <div
                className="flex items-center gap-[9px] rounded-t-[20px] border-[1px] border-[#DADADA] bg-white shadow-custom pt-[3px] h-[65px]  px-[13px]">
                <div
                    className="flex justify-center items-center text-[#BEC3CF] text-[17px] text-center font-[700] w-[30px] h-[30px] border-[2px] border-[#BEC3CF] rounded-full px-2">
                    {index + 1}
                </div>
                <div className="flex w-full items-center  text-[#50555F] text-[17px] font-[700] max-w-[330px]  text-ellipsis">
                    {stageInfo && stageInfo.stageName}
                </div>

                <div
                    className="flex flex-row w-[120px] justify-end items-center text-[#50555F] text-[14px] font-[800] cursor-pointer h-[60px] gap-[6px]"
                    onClick={stageDetail}
                >
                    <div className=" flex justify-end  items-center pb-[1px]">상세보기</div>

                    <img
                        src={HomeRight}
                        alt="right"
                        className="ml-1 w-[8px] items-center"
                    />
                </div>
            </div>
            <div
                className="flex justify-between items-center rounded-b-[20px] border-[1px] border-[#DADADA] bg-white shadow-custom pl-[17px] pr-[38px] py-[16px] mt-[-1px]">
                <div className="flex justify-center items-center gap-5">
                        <img
                            className=" w-[154px] h-[92px] rounded-[10px]"
                            src={stageInfo && getThumbnailUrl(stageInfo.thumbNail)}
                            alt="stage thumbnail"/>

                </div>
                <div className="relative w-[268px] h-[75px] text-[14px] font-[700] text-center">
                    <img
                        src={round2 && round2 > 0 ? StageLineOn : StageLineOff}
                        alt="stage line on/off"
                        className="absolute top-[9px] left-[33px]"
                    />
                    <img
                        src={round3 && round3 > 0 ? StageLineOn : StageLineOff}
                        alt="stage line on/off"
                        className="absolute top-[9px] left-[143px]"
                    />
                    <div className="absolute left-[24px] flex-row justify-center">
                        <img
                            src={round1 && round1 > 0 ? round1 === allStudents ? StageAllClear : StageHalfClear :StageNoneClear}
                            alt="stage clear info"
                        />
                        <div className="text-[#50555F] mt-1">첫번째</div>
                        <div className="text-[#7494FF]">{round1 && round1}/{allStudents && allStudents}명</div>
                    </div>
                    <div className="absolute left-[120px] flex-row justify-center">
                    <img
                        src={round2 && round2 > 0 ? round2 === allStudents ? StageAllClear : StageHalfClear :StageNoneClear}
                            alt="stage clear info"
                        />
                        <div className="text-[#50555F] mt-1">두번째</div>
                        <div className="text-[#7494FF]">{round2 && round2}/{allStudents && allStudents}명</div>
                    </div>
                    <div className="absolute left-[216px] flex-row justify-center">
                        <img
                            src={round3 && round3 > 0 ? round3 === allStudents ? StageAllClear : StageHalfClear :StageNoneClear}
                            alt="stage clear info"
                        />
                        <div className="text-[#50555F] mt-1">세번째</div>
                        <div className="text-[#7494FF]">{round3 && round3}/{allStudents && allStudents}명</div>
                    </div>

                </div>
            </div>
        </div>
    )
}


export default StageBadgeDaily;